// ==============================|| OVERRIDES - DIALOG ||============================== //
// Stejný důvod jako Drawer.js - bez `backgroundImage: 'none'` MUI v tmavém
// režimu kreslí přes Paper elevation overlay (zesvětlující gradient úměrný
// elevation), takže Dialog (elevation 24) vychází viditelně světlejší než
// offcanvas Drawer (elevation overlay tam je potlačený stejným trikem) -
// na výslovné přání uživatele mají mít stejné pozadí.

export default function Dialog() {
  return {
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundImage: 'none'
        }
      }
    }
  };
}
